import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import DownPayment from '../../../../components/Web/CreditDownPayment/redesign/index';
import * as cartActions from '../../../../services/Cart/actions';
import cartSaga from '../../../../services/Cart/sagas';
import injectSaga from '../../../../utils/injectSaga';
import taggingSaga from '../../../Common/Tagging.js/sagas';
import * as taggingActions from '../../../Common/Tagging.js/actions';

const mapStateToProps = (state) => {
  const downPaymentResponse = state.creditDownPayment;
  const currentView = state.currentView || {};

  return {
    downPaymentResponse,
    currentView,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...cartActions, ...taggingActions }, dispatch);
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withSaga = compose(injectSaga({ key: 'cartDetails', saga: cartSaga }), injectSaga({ key: 'taggingDetails', saga: taggingSaga }));

export default withRouter(
  compose(
    withSaga,

    withConnect,
  )(DownPayment),
);
